import React, { lazy, Suspense } from "react";

const LazyAllSellProperty = lazy(() =>
  import("./SellProperty/AllSellProperty")
);
const LazyAllRentProperty = lazy(() =>
  import("./RentProperty/AllRentProperty")
);
const LazyAllSellRequired = lazy(() =>
  import("./RequiredProperty/AllSellRequired")
);
const LazyReEditSellDetail = lazy(() =>
  import("./SellProperty/ReEditSellDetail")
);
const LazyReEditRentDetail = lazy(() =>
  import("./RentProperty/ReEditRentDetail")
);
const LazyReSellListProperty = lazy(() =>
  import("./SellProperty/ReSellListProperty")
);
const LazyReRentListProperty = lazy(() =>
  import("./RentProperty/ReRentListProperty")
);
export const AllSellProperty = () => (
  <Suspense fallback="loading...">
    <LazyAllSellProperty />
  </Suspense>
);
export const AllRentProperty = () => (
  <Suspense fallback="loading...">
    <LazyAllRentProperty />
  </Suspense>
);
export const AllSellRequired = () => (
  <Suspense fallback="loading...">
    <LazyAllSellRequired />
  </Suspense>
);
export const ReEditSellDetail = () => (
  <Suspense fallback="loading...">
    <LazyReEditSellDetail />
  </Suspense>
);
export const ReEditRentDetail = () => (
  <Suspense fallback="loading...">
    <LazyReEditRentDetail />
  </Suspense>
);
export const ReSellListProperty = () => (
  <Suspense fallback="loading...">
    <LazyReSellListProperty />
  </Suspense>
);
export const ReRentListProperty = () => (
  <Suspense fallback="loading...">
    <LazyReRentListProperty />
  </Suspense>
);
